<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 mb-3">
      <div class="breadcrumb-title mt-3 mt-md-0">
        <app-list-header
          title="{{ 'UI_FORM.TITLE' | translate }}"
          icon="bi bi-postcard"
          [$parent]="getSelf()"
        >
        </app-list-header>
      </div>
    </div>

    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <form
            class="row align-items-center mt-1 px-2"
            (keydown.enter)="$event.preventDefault()"
          >
            <div class="row align-items-center compact-inputs dropdown-pd-none">
              <div
                class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2 px-1"
              >
                <div class="d-flex justify-content-start align-items-center">
                  <div class="flex-grow-1">
                    <mat-form-field
                      appearance="outline"
                      subscriptSizing="dynamic"
                      class="w-100"
                    >
                      <mat-label>{{
                        "UI_FORM.USECASE_PLACEHOLDER" | translate
                      }}</mat-label>
                      <input
                        matInput
                        [(ngModel)]="form.searchParams['userstoryName']"
                        id="userstoryName"
                        name="userstoryName"
                        type="text"
                      />
                    </mat-form-field>
                  </div>
                  <button
                    mat-icon-button
                    class="icon-center icon-clean ms-1"
                    [matTooltip]="'UI_FORM.USECASE_PLACEHOLDER' | translate"
                    matTooltipPosition="above"
                  >
                    <mat-icon class="text-secondary icon-compact"
                      >info</mat-icon
                    >
                  </button>
                </div>
              </div>
              <div
                class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2 px-1"
              >
                <div class="d-flex justify-content-start align-items-center">
                  <div class="flex-grow-1">
                    <mat-form-field
                      appearance="outline"
                      subscriptSizing="dynamic"
                      class="w-100"
                    >
                      <mat-label>{{
                        "UI_FORM.TITLE_PLACEHOLDER" | translate
                      }}</mat-label>
                      <input
                        matInput
                        [(ngModel)]="form.searchParams['title']"
                        id="title"
                        name="title"
                        type="text"
                      />
                    </mat-form-field>
                  </div>
                  <button
                    mat-icon-button
                    class="icon-center icon-clean ms-1"
                    [matTooltip]="'UI_FORM.TITLE_PLACEHOLDER' | translate"
                    matTooltipPosition="above"
                  >
                    <mat-icon class="text-secondary icon-compact"
                      >info</mat-icon
                    >
                  </button>
                </div>
              </div>
              <div
                class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-12 mb-2 px-1"
              >
                <div class="d-flex justify-content-start align-items-center">
                  <div class="flex-grow-1">
                    <mat-form-field
                      appearance="outline"
                      subscriptSizing="dynamic"
                      class="w-100"
                    >
                      <mat-label>{{
                        "UI_FORM.SUBTITLE_PLACEHOLDER" | translate
                      }}</mat-label>
                      <input
                        matInput
                        [(ngModel)]="form.searchParams['subtitle']"
                        id="subtitle"
                        name="subtitle"
                        type="text"
                      />
                    </mat-form-field>
                  </div>
                  <button
                    mat-icon-button
                    class="icon-center icon-clean ms-1"
                    [matTooltip]="'UI_FORM.SUBTITLE_PLACEHOLDER' | translate"
                    matTooltipPosition="above"
                  >
                    <mat-icon class="text-secondary icon-compact"
                      >info</mat-icon
                    >
                  </button>
                </div>
              </div>
              <!-- Search  Button -->
              <div class="col-auto mb-2 px-1">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="search()"
                  class="btn-sm"
                >
                  <mat-icon>search</mat-icon> {{ "COMMON.SEARCH" | translate }}
                </button>
              </div>
              <!-- Reset Button -->
              <div class="col-auto mb-2 px-1">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="resetSearchForm()"
                  class="btn-sm"
                  id="marginSet"
                >
                  <i class="fa fa-eraser"></i>
                  <span class="ms-2">{{
                    "APP_STORE.SEARCH.RESET" | translate
                  }}</span>
                </button>
              </div>
              <!-- Dashboard Filter Toggle Button -->
              <div class="col-auto mb-2 px-1">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="iconSearch()"
                  class="icon-center icon-width"
                  [matTooltip]="
                    isDashboardFilterActive
                      ? ('UI_FORM.REMOVE_DASHBOARD_FILTER' | translate)
                      : ('UI_FORM.SEARCH_DASHBOARD' | translate)
                  "
                >
                  <mat-icon *ngIf="!isDashboardFilterActive"
                    >dashboard_customize</mat-icon
                  >
                  <mat-icon *ngIf="isDashboardFilterActive">close</mat-icon>
                </button>
              </div>
              <!-- Archive/Main List Toggle Button -->
              <div class="col-auto mb-2 px-1">
                <button
                  *ngIf="!isArchivedlistTabActive"
                  mat-stroked-button
                  color="primary"
                  [attr.aria-label]="'UI_FORM.VIEW_ARCHIVE' | translate"
                  [matTooltip]="'UI_FORM.VIEW_ARCHIVE' | translate"
                  (click)="toggleTab('archivedlist')"
                  class="icon-center icon-width"
                >
                  <mat-icon style="transform: rotate(180deg)">archive</mat-icon>
                </button>

                <button
                  *ngIf="isArchivedlistTabActive"
                  mat-stroked-button
                  color="primary"
                  [attr.aria-label]="'UI_FORM.VIEW_MAIN_LIST' | translate"
                  [matTooltip]="'UI_FORM.VIEW_MAIN_LIST' | translate"
                  (click)="toggleTab('mainlist')"
                  class="icon-center icon-width"
                >
                  <mat-icon>list</mat-icon>
                </button>
              </div>
              <!-- Trash Button -->
              <div class="col-auto mb-2 px-1">
                <button
                  mat-stroked-button
                  color="primary"
                  [attr.aria-label]="'UI_FORM.VIEW_TRASH' | translate"
                  [matTooltip]="'UI_FORM.VIEW_TRASH' | translate"
                  (click)="toggleTab('trashlist')"
                  class="icon-center icon-width"
                >
                  <mat-icon>delete_forever</mat-icon>
                  <!-- <span>{{ 'UI_FORM.TRASH' | translate }}</span> -->
                </button>
              </div>
            </div>

            <div *ngIf="form.error" class="alert alert-danger mt-2">
              {{ form.message }}
            </div>
          </form>

          <div class="tab-content" id="pills-tabContent">
            <div
              class="tab-pane fade"
              [class.show]="!isArchivedlistTabActive && !isTrashTabActive"
              [class.active]="!isArchivedlistTabActive && !isTrashTabActive"
              id="pills-home"
              role="tabpanel"
              aria-labelledby="pills-home-tab"
            >
              <div class="my-3" *ngIf="form.list.length > 0">
                <!-- Alert messages -->
                <p
                  *ngIf="form['searchError'] == false && form['searchMessage']"
                >
                  <app-ncs-alert
                    [message]="form['searchMessage']"
                    type="success"
                  />
                </p>
                <p *ngIf="form['searchError'] == true && form['searchMessage']">
                  <app-ncs-alert
                    [message]="form['searchMessage']"
                    type="danger"
                  />
                </p>

                <!-- Table -->
                <div class="table-container mb-3">
                  <div class="table-responsive table-scrollable">
                    <table class="table table-bordered table-sticky-header">
                      <thead>
                        <tr>
                          <th class="text-center">
                            {{ "UI_FORM.TABLE.SNO" | translate }}
                          </th>

                          <th class="text-nowrap sortable-header">
                            <span
                              class="header-label"
                              (click)="sortTable('title')"
                            >
                              {{ "UI_FORM.TABLE.TITLE" | translate }}
                              <ng-container
                                *ngTemplateOutlet="
                                  sortIcons;
                                  context: { key: 'title' }
                                "
                              ></ng-container>
                            </span>
                          </th>

                          <th class="text-nowrap sortable-header">
                            <span
                              class="header-label"
                              (click)="sortTable('subtitle')"
                            >
                              {{ "UI_FORM.TABLE.SUBTITLE" | translate }}
                              <ng-container
                                *ngTemplateOutlet="
                                  sortIcons;
                                  context: { key: 'subtitle' }
                                "
                              ></ng-container>
                            </span>
                          </th>

                          <th class="text-nowrap sortable-header">
                            <span
                              class="header-label"
                              (click)="sortTable('userstoryName')"
                            >
                              {{ "UI_FORM.TABLE.USECASE" | translate }}
                              <ng-container
                                *ngTemplateOutlet="
                                  sortIcons;
                                  context: { key: 'userstoryName' }
                                "
                              ></ng-container>
                            </span>
                          </th>

                          <th class="text-nowrap sortable-header">
                            <span
                              class="header-label"
                              (click)="sortTable('applicationName')"
                            >
                              {{ "UI_FORM.TABLE.APPLICATION" | translate }}
                              <ng-container
                                *ngTemplateOutlet="
                                  sortIcons;
                                  context: { key: 'applicationName' }
                                "
                              ></ng-container>
                            </span>
                          </th>

                          <th>{{ "UI_FORM.TABLE.ACTIONS" | translate }}</th>
                        </tr>

                        <ng-template #sortIcons let-key="key">
                          <i
                            *ngIf="sortedField === key && sortOrder === 'ASC'"
                            class="fa fa-sort-up ms-1 text-dark"
                          ></i>
                          <i
                            *ngIf="sortedField === key && sortOrder === 'DESC'"
                            class="fa fa-sort-down ms-1 text-dark"
                          ></i>
                          <i
                            *ngIf="sortedField !== key"
                            class="fa fa-sort ms-1 text-muted"
                          ></i>
                        </ng-template>
                      </thead>
                      <tbody>
                        <tr *ngFor="let e of form.list; let i = index">
                          <td class="text-center">{{ pageIndex(i) }}</td>
                          <td>{{ e["title"] }}</td>
                          <td>{{ e["subtitle"] }}</td>
                          <td>{{ e["userstoryName"] }}</td>
                          <td>{{ e["applicationName"] | truncate }}</td>

                          <!-- Actions -->
                          <td class="text-center">
                            <div
                              class="d-flex gap-2 align-items-center justify-content-start p-0 m-0"
                            >
                              <!-- View Form Button -->
                              <button
                                mat-stroked-button
                                color="primary"
                                class="icon-center icon-width"
                                matTooltipPosition="above"
                                [matTooltip]="'UI_FORM.VIEW_FORM' | translate"
                                (click)="gotoForm(e.id)"
                              >
                                <mat-icon class="icon-compact"
                                  >visibility</mat-icon
                                >
                              </button>

                              <!-- Add/Remove Dashboard Button -->
                              <button
                                mat-stroked-button
                                color="primary"
                                class="icon-center icon-width"
                                (click)="addDashboard(e['id'])"
                                matTooltipPosition="above"
                                [matTooltip]="
                                  !e['showDashboard'] ||
                                  e['showDashboard'] === null ||
                                  e['showDashboard'] === 0
                                    ? ('UI_FORM.ADD_DASHBOARD' | translate)
                                    : ('UI_FORM.REMOVE_DASHBOARD' | translate)
                                "
                              >
                                <mat-icon
                                  *ngIf="
                                    !e['showDashboard'] ||
                                    e['showDashboard'] === null ||
                                    e['showDashboard'] === 0
                                  "
                                >
                                  dashboard_customize
                                </mat-icon>
                                <mat-icon *ngIf="e['showDashboard'] === 1">
                                  close
                                </mat-icon>
                              </button>

                              <!-- Edit Button -->
                              <button
                                mat-stroked-button
                                color="primary"
                                class="icon-center icon-width"
                                matTooltipPosition="above"
                                [matTooltip]="'COMMON.EDIT' | translate"
                                routerLink="/uiformcreate/{{
                                  e['userstoryId']
                                }}"
                              >
                                <mat-icon>edit</mat-icon>
                              </button>

                              <!-- Archive Button -->
                              <button
                                mat-stroked-button
                                color="primary"
                                class="icon-center icon-width"
                                matTooltipPosition="above"
                                [matTooltip]="'UI_FORM.ARCHIVE' | translate"
                                (click)="delete(e.id)"
                              >
                                <mat-icon>archive</mat-icon>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <app-list-header [$parent]="getSelf()"></app-list-header>
              </div>

              <!-- No records message -->
              <div
                class="mt-3 text-danger bg-col-danger"
                *ngIf="
                  form.searchParams['applicationName'] && form.list.length === 0
                "
              >
                {{ "UI_FORM.NO_RECORDS_FOUND" | translate }}
              </div>
            </div>

            <!-- Archived List Tab -->
            <div
              class="tab-pane fade"
              [class.show]="isArchivedlistTabActive && !isTrashTabActive"
              [class.active]="isArchivedlistTabActive && !isTrashTabActive"
              id="pills-profile"
              role="tabpanel"
              aria-labelledby="pills-profile-tab"
            >
              <div class="table-responsive mt-3 mb-3">
                <p
                  *ngIf="form['searchError'] == false && form['searchMessage']"
                >
                  <app-ncs-alert
                    [message]="form['searchMessage']"
                    type="success"
                  />
                </p>
                <p *ngIf="form['searchError'] == true && form['searchMessage']">
                  <app-ncs-alert
                    [message]="form['searchMessage']"
                    type="danger"
                  />
                </p>
                <div class="table-container mb-3">
                  <div class="table-responsive table-scrollable">
                    <table class="table table-bordered table-sticky-header">
                      <thead>
                        <tr>
                          <th class="text-center">
                            {{ "UI_FORM.TABLE.SNO" | translate }}
                          </th>

                          <th class="text-nowrap sortable-header">
                            <span
                              class="header-label"
                              (click)="sortTable('title')"
                            >
                              {{ "UI_FORM.TABLE.TITLE" | translate }}
                              <ng-container
                                *ngTemplateOutlet="
                                  sortIcons;
                                  context: { key: 'title' }
                                "
                              ></ng-container>
                            </span>
                          </th>

                          <th class="text-nowrap sortable-header">
                            <span
                              class="header-label"
                              (click)="sortTable('subtitle')"
                            >
                              {{ "UI_FORM.TABLE.SUBTITLE" | translate }}
                              <ng-container
                                *ngTemplateOutlet="
                                  sortIcons;
                                  context: { key: 'subtitle' }
                                "
                              ></ng-container>
                            </span>
                          </th>

                          <th class="text-nowrap sortable-header">
                            <span
                              class="header-label"
                              (click)="sortTable('userstoryName')"
                            >
                              {{ "UI_FORM.TABLE.USECASE" | translate }}
                              <ng-container
                                *ngTemplateOutlet="
                                  sortIcons;
                                  context: { key: 'userstoryName' }
                                "
                              ></ng-container>
                            </span>
                          </th>

                          <th class="text-nowrap sortable-header">
                            <span
                              class="header-label"
                              (click)="sortTable('applicationName')"
                            >
                              {{ "UI_FORM.TABLE.APPLICATION" | translate }}
                              <ng-container
                                *ngTemplateOutlet="
                                  sortIcons;
                                  context: { key: 'applicationName' }
                                "
                              ></ng-container>
                            </span>
                          </th>

                          <th class="text-center">
                            {{ "UI_FORM.TABLE.ACTIONS" | translate }}
                          </th>
                        </tr>

                        <ng-template #sortIcons let-key="key">
                          <i
                            *ngIf="sortedField === key && sortOrder === 'ASC'"
                            class="fa fa-sort-up ms-1 text-dark"
                          ></i>
                          <i
                            *ngIf="sortedField === key && sortOrder === 'DESC'"
                            class="fa fa-sort-down ms-1 text-dark"
                          ></i>
                          <i
                            *ngIf="sortedField !== key"
                            class="fa fa-sort ms-1 text-muted"
                          ></i>
                        </ng-template>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="let e of form['archivedlist']; let i = index"
                        >
                          <td class="text-center">{{ pageIndex(i) }}</td>
                          <td>{{ e["title"] }}</td>
                          <td>{{ e["subtitle"] }}</td>
                          <td>{{ e["userstoryName"] }}</td>
                          <td>{{ e["applicationName"] | truncate }}</td>
                          <td class="text-center">
                            <button
                              mat-stroked-button
                              color="primary"
                              [matTooltip]="'UI_FORM.RETRIEVE' | translate"
                              matTooltipPosition="above"
                              class="icon-center icon-width"
                              (click)="retrieve(e.id)"
                            >
                              <mat-icon>unarchive</mat-icon>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <app-list-header [$parent]="getSelf()"></app-list-header>
              </div>
            </div>

            <!-- Trash Tab -->
            <div
              class="tab-pane fade"
              [class.show]="isTrashTabActive"
              [class.active]="isTrashTabActive"
              id="pills-trash"
              role="tabpanel"
              aria-labelledby="pills-trash-tab"
            >
              <div class="my-3">
                <p
                  *ngIf="form['searchError'] == false && form['searchMessage']"
                >
                  <app-ncs-alert
                    [message]="form['searchMessage']"
                    type="success"
                  />
                </p>
                <p *ngIf="form['searchError'] == true && form['searchMessage']">
                  <app-ncs-alert
                    [message]="form['searchMessage']"
                    type="danger"
                  />
                </p>
                <div class="table-container mb-3">
                  <div class="table-responsive table-scrollable">
                    <table class="table table-bordered table-sticky-header">
                      <thead>
                        <tr>
                          <th class="text-center">
                            {{ "UI_FORM.TABLE.SNO" | translate }}
                          </th>

                          <th class="text-nowrap sortable-header">
                            <span
                              class="header-label"
                              (click)="sortTable('title')"
                            >
                              {{ "UI_FORM.TABLE.TITLE" | translate }}
                              <ng-container
                                *ngTemplateOutlet="
                                  sortIcons;
                                  context: { key: 'title' }
                                "
                              ></ng-container>
                            </span>
                          </th>

                          <th class="text-nowrap sortable-header">
                            <span
                              class="header-label"
                              (click)="sortTable('subtitle')"
                            >
                              {{ "UI_FORM.TABLE.SUBTITLE" | translate }}
                              <ng-container
                                *ngTemplateOutlet="
                                  sortIcons;
                                  context: { key: 'subtitle' }
                                "
                              ></ng-container>
                            </span>
                          </th>

                          <th class="text-nowrap sortable-header">
                            <span
                              class="header-label"
                              (click)="sortTable('userstoryName')"
                            >
                              {{ "UI_FORM.TABLE.USECASE" | translate }}
                              <ng-container
                                *ngTemplateOutlet="
                                  sortIcons;
                                  context: { key: 'userstoryName' }
                                "
                              ></ng-container>
                            </span>
                          </th>

                          <th class="text-nowrap sortable-header">
                            <span
                              class="header-label"
                              (click)="sortTable('applicationName')"
                            >
                              {{ "UI_FORM.TABLE.APPLICATION" | translate }}
                              <ng-container
                                *ngTemplateOutlet="
                                  sortIcons;
                                  context: { key: 'applicationName' }
                                "
                              ></ng-container>
                            </span>
                          </th>

                          <th class="text-center">
                            {{ "UI_FORM.TABLE.ACTIONS" | translate }}
                          </th>
                        </tr>

                        <ng-template #sortIcons let-key="key">
                          <i
                            *ngIf="sortedField === key && sortOrder === 'ASC'"
                            class="fa fa-sort-up ms-1 text-dark"
                          ></i>
                          <i
                            *ngIf="sortedField === key && sortOrder === 'DESC'"
                            class="fa fa-sort-down ms-1 text-dark"
                          ></i>
                          <i
                            *ngIf="sortedField !== key"
                            class="fa fa-sort ms-1 text-muted"
                          ></i>
                        </ng-template>
                      </thead>
                      <tbody>
                        <tr *ngFor="let e of form['trashlist']; let i = index">
                          <td class="text-center">{{ pageIndex(i) }}</td>
                          <td>{{ e["title"] }}</td>
                          <td>{{ e["subtitle"] }}</td>
                          <td>{{ e["userstoryName"] }}</td>
                          <td>{{ e["applicationName"] | truncate }}</td>
                          <td class="text-center">
                            <button
                              [attr.title]="'UI_FORM.RETRIEVE' | translate"
                              class="btn btn-sm btn-outline-success sm-btn p-1"
                              (click)="retrieve(e.id)"
                            >
                              <i class="bx bx-archive-out p-0"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <app-list-header [$parent]="getSelf()"></app-list-header>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>